import { BookHeart, FlaskConical, Pause, Play, Square } from "lucide-react";
import { experimentFrom } from "@/hooks/useCompanionChat";

const voiceButtonLabel=(active,status)=>{
  if(!active)return"Play voice";
  if(status==="playing")return"Pause voice";
  if(status==="loading")return"Preparing voice…";
  if(status==="paused")return"Resume voice";
  return"Play voice";
};

const VoiceControls=({message,index,speech})=>{
  const active=speech.activeId===message.id;
  const label=voiceButtonLabel(active,speech.status);
  return <div className="voice-actions" data-testid={`voice-controls-${index+1}`}>
    <button onClick={()=>speech.toggle(message.id,message.text)} disabled={active&&speech.status==="loading"} aria-label={label} data-testid={`voice-toggle-${index+1}-button`}>
      {active&&speech.status==="playing"?<Pause/>:<Play/>}{label}
    </button>
    {active&&speech.status!=="idle"&&<button onClick={speech.stop} aria-label="Stop voice" data-testid={`voice-stop-${index+1}-button`}><Square/>Stop</button>}
  </div>;
};

const MessageActions=({message,index,savedExperiments,savedJournal,onSaveExperiment,onSaveJournal})=>{
  const experiment=experimentFrom(message.text);
  const experimentSaved=savedExperiments.includes(message.id);
  const journalSaved=savedJournal.includes(message.id);
  return <div className="message-actions">
    {experiment&&<button onClick={()=>onSaveExperiment(message)} disabled={experimentSaved} data-testid={`save-companion-experiment-${index+1}-button`}><FlaskConical/>{experimentSaved?"Saved to Today":"Try in real life"}</button>}
    <button onClick={()=>onSaveJournal(message)} disabled={journalSaved} data-testid={`save-companion-journal-${index+1}-button`}><BookHeart/>{journalSaved?"Saved to Journal":"Keep in Journal"}</button>
  </div>;
};

export const ConversationMessage=({message,index,savedExperiments,savedJournal,onSaveExperiment,onSaveJournal,speech})=>{
  const isGuide=message.role==="guide";
  const actionable=Boolean(message.parentInsight&&message.text);
  return <div className={`message ${message.role}`} data-testid={`message-${message.id}`}>
    <small>{message.role==="you"?"You":"SHANE"}</small>
    <p>{message.text||"Listening…"}</p>
    {isGuide&&message.text&&speech&&<VoiceControls message={message} index={index} speech={speech}/>}
    {actionable&&<MessageActions message={message} index={index} savedExperiments={savedExperiments} savedJournal={savedJournal} onSaveExperiment={onSaveExperiment} onSaveJournal={onSaveJournal}/>}
  </div>;
};